import { SingleEmployee } from './SingleEmployee';

export default SingleEmployee;
